import { createStore, Store, useStore as baseUseStore } from "vuex";
import { InjectionKey } from "vue";
import authModule, { AuthState } from "./modules/auth";
import recordModule, { RecordState } from "@/store/modules/record";
import prefModule, { PrefState } from "@/store/modules/pref";
import memoModule, { MemoState } from "@/store/modules/memo";
import createPersistedState from "vuex-persistedstate";
import userModule, { UserState } from "@/store/modules/user";
import musicQueryModule, { MusicQueryState } from "@/store/modules/musicQuery";
import calendarModule, { CalendarState } from "@/store/modules/calendar";
import loadingModule, { LoadingState } from "@/store/modules/loading";

export type State = {
  auth: AuthState;
  record: RecordState;
  pref: PrefState;
  memo: MemoState;
  user: UserState;
  musicQuery: MusicQueryState;
  calendar: CalendarState;
  loading: LoadingState;
};

export const key: InjectionKey<Store<State>> = Symbol();

export function useStore() {
  return baseUseStore(key);
}

const store = createStore<State>({
  modules: {
    auth: authModule,
    record: recordModule,
    pref: prefModule,
    memo: memoModule,
    user: userModule,
    musicQuery: musicQueryModule,
    calendar: calendarModule,
    loading: loadingModule,
  },
  plugins: [
    createPersistedState({
      key: "IIDX_Viewer",
      paths: ["pref"],
      storage: window.localStorage,
    }),
  ],
});
export default store;
